<template>
  <div>
    <div class="bar">
		<div class="bar-logo"><router-link to="/"><img src="../../assets/logo.png"></router-link></div>
		<div class="bar-nav">
			<router-link class="bar-list-a" :to="obj.path" v-for="(obj,index) in barList" :key="index">
			  <div class="bar-list">
			  
			    <span>{{obj.name}}</span>
			  </div>
			</router-link>
		</div>
    
	  <div class="bar-menu">
		  <ul>
			<!--  <li><img src="../../assets/icon31.png"></li> -->
		<!-- 	<span><a href="http://en.fmhd.209.qiyundongli.cn/">英文</a></span> -->
		<input type="text" v-if="ind" v-model="key" v-on:keyup.13="lidear">
		  <li v-if="ind"><router-link :to="'/product/list?key='+key"><img  class="finding" src="../../assets/find.png"></router-link></li>
		   <li v-if="!ind" @click="ind=true"><img class="finding" src="../../assets/find.png"></li>
			 <span><a @click="sign" v-if="fix">退出</a><router-link v-else to="/login">登入</router-link></span>
			   <li class="img"><a href="http://en.fuelme.com.cn/"><img src="../../assets/china.png"></a></li>
			   <li><router-link to="/user/gift"><img src="../../assets/icon32.png"></router-link></li>
			    <li><router-link to="/product/cart"><img src="../../assets/icon33.png"></router-link></li>
				 
		  </ul>
	  </div>
    </div>
	<div class="cand"></div>

  </div>
</template>
<script>
import index from "@/assets/bar/index.png";
import index_action from "@/assets/bar/index_action.png";
import serve from "@/assets/bar/serve.png";
import serve_action from "@/assets/bar/serve_action.png";
import user from "@/assets/bar/user.png";
import user_action from "@/assets/bar/user_action.png";
import notice from "@/assets/bar/notice.png";
import notice_action from "@/assets/bar/notice_action.png";
import act from "@/assets/bar/act.png";
import act_action from "@/assets/bar/act_action.png";


export default {
  data() {
    return {
      barBtn: 0,
	  key:'',
	  ind:false,
	  fix:true,
      barList: [
        {
          name: "首頁",
          path: "/index/home",
          icon: index,
          icon_action: index_action,
        },
        {
          name: "產品",
          path: "/product",
          icon: serve,
          icon_action: serve_action,
        }, {
          name: "新聞",
          path: "/news",
          icon: notice,
          icon_action: notice_action,
        }, {
          name: "作品鑒賞",
          path: "/works",
          icon: act,
          icon_action: act_action,
        },
        {
          name: "聯繫我們",
          path: "/contact",
          icon: user,
          icon_action: user_action,
        },
      ],
    };
  },
  mounted() {
  	  this.getLog()
		
  		},
  methods: {
    getLog() {
     if(window.localStorage.getItem('user')== "undefined"||!window.localStorage.hasOwnProperty('user')){
     	this.fix=false
     }else{
     	this.fix=true
     }
    },sign(){
		window.localStorage.clear()
		this.$router.push({ path: "/login" });	
	},lidear(){
		this.$router.push({ path: "/product/list?key="+this.key });	
	}
  },
};
</script>

<style lang='scss' scoped>
.bar {
	position: fixed;
	top: 0;
	z-index: 999;
display: flex;
justify-content: space-between;
align-items: center;
border-bottom: 3px solid #EEEEEE;

  width: 100%;
  height: 94px;
  padding:10px 61px;
  box-sizing: border-box;
  background: white;
	.bar-logo{
		
		img{
			width: 152px;
			height: 73px;
		}
	}
	.bar-nav{
		width:590px;
		display: flex;
		justify-content: space-evenly;
		font-size: 16px;
		a{
			color: #000000;
		}
	}
	.bar-menu{
		
		span{
			float: left;
			margin-right: 20px;
			padding-top: 5px;
		}
		input{
			float: left;
			height: 22px;
			margin-right: 10px;
		}
		li{
			width: 30px;
			height: 30px;
			float: left;
			margin-right: 20px;
			img{
				width: 100%;
				height: 100%;
				image-rendering: -webkit-optimize-contrast;
			}
			.finding{
				width: 25px;
				height: 25px;
			}
		}
		.img{
			width: 30px;
			height: 19px;
			padding-top: 7px;
		}

	}
  .bar-list {
	
    .bar-list-img {
    
      width: 49px;
      height: 49px;
      margin: auto;
      box-sizing: border-box;
      img {
        width: 100%;
      }
      .icon_action {
        display: none;
      }
      .icon {
        display: block;
      }
    }
  }
  //

  //
  .bar-nav{
	  .router-link-active{
	  	  border-bottom: 2px solid #000000;
	  	  .icon_action {
	  	    display: block !important ;
	  	  }
	  	  .icon {
	  	    display: none !important ;
	  	  }
	  }
	  .router-link-exact-active {
	   border-bottom: 2px solid #000000;
	    .icon_action {
	      display: block !important ;
	    }
	    .icon {
	      display: none !important ;
	    }
	  }
  }

}
.cand{
	width: 100%;
	height: 94px;
}
</style>